import { Container } from "react-bootstrap";
import { Route, Switch, useRouteMatch } from "react-router";
import AddCorreos from "./AddCorreos";
import CorreosList from "./CorreosList";

function CorreosIndex(){
    let { path, url } = useRouteMatch();
    return(
        <Container fluid className="my-5">
            <Switch>
                <Route exact path={path}><CorreosList url={url}/></Route>
                <Route exact path={`${path}/crear`}><AddCorreos /></Route>
            </Switch>
        </Container>
    )

}

export default CorreosIndex